<template>
    <div class="m-0 p-0">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">

                    </div>
                    <div class="card-body table-responsive">
                        <div class="row mb-2">
                            <div class="col-lg-3 col-md-6 col-12 mb-2">
                                <label>{{$t("report.date.startDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.startDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>
                            <div class="col-lg-3 col-md-6 col-12 mb-2">
                                <label>{{$t("report.date.endDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.endDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>
                            <div class="col-lg-4 col-md-9 col-12 mb-2">
                                <label for="search">{{$t('finance.field.search')}}</label>
                                <div class="input-group">
                                    <input class="form-control search-input" type="text" :placeholder="$t('main.search')"
                                           id="search"
                                           v-model.trim="filter.search" @keypress.enter="initList">
                                    <div class="input-group-append">
                                        <button class="all-btn search-btn" @click="initList">
                                            <i class="fa fa-search"></i>
                                          <span>{{$t('finance.field.search')}}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-3 col-12 align-self-end align-content-end">
                                <button class="all-btn ml-md-auto m-0 mb-2" type="button" @click="addFixedExpenseType">
                                    {{$t('common.add')}}
                                </button>
                                <fixed-expense-type-add-edit-view></fixed-expense-type-add-edit-view>
                            </div>
                        </div>
                        <div class="row">
                            <div class="table-wrapper w-100">
                              <table class="customers">
                                <thead>
                                    <tr>
                                        <th width="10%">#</th>
                                        <th class="text-center">{{$t('common.name')}}</th>
                                        <th class="text-center">{{$t('common.code')}}</th>
                                        <th class="text-center" width="15%">{{$t('finance.field.action')}}</th>
                                    </tr>
                                </thead>
                                <tbody v-if="!loading && results && results.data">
                                    <tr v-for="result in results.data" :key="result.id">
                                        <td>{{result.id}}</td>
                                        <td class="text-center">{{result.name}}</td>
                                        <td class="text-center">{{result.code}}</td>
                                        <td class="text-center">
                                            <button class="all-btn edit-btn" type="button" @click="editFixedExpenseType(result)">
                                                <i class="fa fa-edit"></i>
                                              <span>{{$t('action.edit')}}</span>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.total && results.total > 1">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import initFilterModel from '@/shared/filter'
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import Datepicker from 'vuejs-datepicker';
    import FixedExpenseTypeAddEditView from "@/views/finance/debit/FixedExpenseTypeAddEditView";


    export default {
        name: "FixedExpenseTypeList",
        components: {
            'b-pagination': bPagination,
            Datepicker,
            FixedExpenseTypeAddEditView,
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null,
                data: null,
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('fixed-expense-type/list', this.filter)
                    .then(res => {
                        this.results = res.data
                        this.loading = false
                    }, err => {
                        console.log(err);
                        this.loading = false
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            addFixedExpenseType() {
                this.$eventBus.$emit('showFixedExpenseTypeAddEditView', {code: 'add'});
            },
            editFixedExpenseType(result) {
                this.$eventBus.$emit('showFixedExpenseTypeAddEditView', {id: result.id, code: 'edit'});
            },
            checkCardTrans(data) {
                console.log(data);
                // this.$http.post('uzcard/check-transaction', data)
                //     .then(res => {
                //         if (res && res.data && res.data.status === 'SUCCESS') {
                //             this.data = res.data;
                //             this.modalTitle = 'Uzcard транзакция текшириш'
                //             this.$eventBus.$emit("showBaseModal")
                //             this.initList()
                //         } else {
                //             this.$swal({
                //                 title: this.$t('messages.common.warning'),
                //                 text: res.data.message,
                //                 type: 'warning'
                //             });
                //         }
                //     }, err => {
                //         console.log(err)
                //     })
            },
            cancelCardTrans(/*data*/) {
                // this.$swal({
                //     title: this.$t('messages.common.warning'),
                //     text: this.$t('messages.uzCard.cancelCardTransConfirm'),
                //     type: 'warning',
                //     showCancelButton: true,
                //     confirmButtonColor: '#87CB16',
                //     confirmButtonText: 'Бажариш',
                //     cancelButtonText: 'Бекор қилиш'
                // }).then((result) => {
                //     if (result.value) {
                //         this.$http.post('uzcard/cancel-transaction', data)
                //             .then(res => {
                //                 if (res && res.data && res.data.status === 'SUCCESS') {
                //                     this.data = res.data;
                //                     this.modalTitle = 'Uzcard транзакция бекор қилиш'
                //                     this.$eventBus.$emit("showBaseModal")
                //                     this.initList()
                //                 } else {
                //                     this.$swal({
                //                         title: this.$t('messages.common.warning'),
                //                         text: res.data.message,
                //                         type: 'warning'
                //                     });
                //                 }
                //             }, err => {
                //                 console.log(err)
                //             })
                //     }
                // });
            }
        },
        created() {
            this.initList()

            this.$eventBus.$on('refreshFixedExpenseTypeList', (data) => {
                console.log(data);
                this.initList();
                if (data.isNew){
                    this.$eventBus.$emit('refreshFixedExpenseTypeSelect', data);
                }

            })
        },
        computed: {

        }
    }
</script>

<style scoped>

</style>